import React, { useEffect, useState } from 'react';
import {
    Modal,
    Form,
    Input,
    Select,
    Button,
    Row,
    Col,
    DatePicker,
    InputNumber,
    Space, Input as AntInput,Divider,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

import UnitTypeModel from '../../masters/unit-types/UnitTypeModel';
import type {
    Ledger,
    Products,
    Pn,
    Categories,
    BrandNames,
    GST,
    Qn,
    Qnum,
    Fts,
    Bc,
    Sc,
    Count,
    Composition,
    Finish,
    Width,
    Hc,
    Pf,
    FPs,
    SaleType,
    Pus,
    Carings,
    Size,
    It,
    Sn,
    UnitType,
    ProductVariants,
    ProductGrades,
    BookNumbers,
    CardNumbers,
    RackNumbers,
    BlockNumbers,
    Places,
} from '../../../../types/CreateProductType';


import BookNumberModel from '../../masters/booknumber/BookNumberModel';
import CardNumberModel from '../../masters/cardnumber/CardNumberModel';
import RackNumberModel from '../../masters/racknumber/RackNumberModel';
import BlockNumberModel from '../../masters/blocknumber/BlockNumberModel';
import PlaceModel from '../../masters/places/PlaceModel';
import SizeModel from '../../masters/sizes/SizeModel'; 
import SnModal from '../../masters/shade-numbers/SnModal'; 
import BcModal from '../../masters/base-colors/BcModal';
import PuModal from '../../masters/product-uses/PuModal';
import ScModal from '../../masters/sub-colors/ScModal';
import ProducrGradeModel from '../../masters/product-grades/ProducrGradeModel';




const numberToLetters = (num: number): string => {
    let result = '';
    do {
        result = String.fromCharCode((num % 26) + 65) + result;
        num = Math.floor(num / 26) - 1;
    } while (num >= 0);
    return result;
};
interface ProductModelProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void;
    variantinitialValues?: ProductVariants | null;
    initialValues?: Products | null;
    isEditMode?: boolean;
    product_id?: number | null;
    productVariants?: ProductVariants[] | null;
}

const VariantsModel: React.FC<ProductModelProps> = ({
    visible,
    onCancel,
    onCreate,
    variantinitialValues = null,
    isEditMode = false,
    product_id = null,
    productVariants = null,
    initialValues = null,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);

    // Example master data sources
    const [suppliers, setSuppliers] = useState([]);
    const [baseColors, setBaseColors] = useState([]);
    const [subColors, setSubColors] = useState([]);
    const [grades, setGrades] = useState([]);

    const [unitTypes, setUnitTypes] = useState<UnitType[]>([]);
    const [selectedUt, setSelectedUt] = useState<number | null>(null);
    const [isUtModalVisible, setIsUtModalVisible] = useState(false);

    const [sns, setSns] = useState<Sn[]>([]);
    const [selectedSn, setSelectedSn] = useState<number | null>(null);
    const [isSnModalVisible, setIsSnModalVisible] = useState(false);

    const [sizes, setSizes] = useState<Size[]>([]);
    const [selectedSize, setSelectedSize] = useState<number | null>(null);
    const [isSizeModalVisible, setIsSizeModalVisible] = useState(false);

    const [bcs, setBcs] = useState<Bc[]>([]);
    const [selectedBcs, setSelectedBcs] = useState<number | null>(null);
    const [isBcModalVisible, setIsBcModalVisible] = useState(false);


    const [scs, setScs] = useState<Sc[]>([]);
    const [selectedScs, setSelectedScs] = useState<number | null>(null);
    const [isScModalVisible, setIsScModalVisible] = useState(false);

    const [booknumbers, setBookNumbers] = useState<BookNumbers[]>([]);
    const [selectedBooknumber, setSelectedBooknumber] = useState<number | null>(null);
    const [isBooknumberModalVisible, setIsBooknumberModalVisible] = useState(false);

    const [cardnumbers, setCardNumbers] = useState<CardNumbers[]>([]);
    const [selectedCn, setSelectedCn] = useState<number | null>(null);
    const [isCnModalVisible, setIsCnModalVisible] = useState(false);


    const [RackNumbers, setRackNumbers] = useState<RackNumbers[]>([]);
    const [selectedRn, setSelectedRn] = useState<number | null>(null);
    const [isRnModalVisible, setIsRnModalVisible] = useState(false);


    const [blocknumbers, setBlockNumbers] = useState<BlockNumbers[]>([]);
    const [selectedBlocknumber, setSelectedBlocknumber] = useState<number | null>(null);
    const [isBlocknumberModalVisible, setIsBlocknumberModalVisible] = useState(false);


    const [places, setPlaces] = useState<Places[]>([]);
    const [selectedPlace, setSelectedPlace] = useState<number | null>(null);
    const [isPlaceModalVisible, setIsPlaceModalVisible] = useState(false);


    const [ledgers, setLedgers] = useState<Ledger[]>([]);


    const [currentVariantId, setCurrentVariantId] = useState<number | null>(null);

    const [Pus, setPus] = useState<Pus[]>([]);
    const [selectedPus, setSelectedPus] = useState<number | null>(null);
    const [isPusModalVisible, setIsPusModalVisible] = useState(false);

    
    const [productgrades, setProductGrades] = useState<ProductGrades[]>([]);
    const [selectedPg, setSelectedPg] = useState<number | null>(null);
    const [isPgModalVisible, setIsPgModalVisible] = useState(false);


    console.log("initialValues", initialValues);

    // Fetch data on mount
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const [unit, snsNom, sizeData, baseColordata, subColordata, ledgerData, ProductGradeData] = await Promise.all([

    //                 apiRequest({ url: 'unit-types?status=1' }),
    //                 apiRequest({ url: 'shade-numbers?status=1' }),
    //                 apiRequest({ url: 'sizes?status=1' }),
    //                 apiRequest({ url: 'base-colors?status=1' }),
    //                 apiRequest({ url: 'sub-colors?status=1' }),
    //                 apiRequest({ url: 'ledger-data?status=1' }),
    //                 apiRequest({ url: 'product-grades?status=1' }),
    //             ]);

    //             setUnitTypes(unit || []);
    //             setSns(snsNom || []);
    //             setSizes(sizeData || []);
    //             setBcs(baseColordata || []);
    //             setScs(subColordata || []);
    //             setLedgers(ledgerData.ledgers || []);
    //             setProductGrades(ProductGradeData || []);
    //             // Sequential fetches (await one by one)
    //             const bookNumbersData = await apiRequest({ method: 'get', url: `book?status=1` });
    //             setBookNumbers(bookNumbersData);

    //             const cardNumbersData = await apiRequest({ method: 'get', url: `card?status=1` });
    //             setCardNumbers(cardNumbersData);

    //             const rackNumbersData = await apiRequest({ method: 'get', url: `rack?status=1` });
    //             setRackNumbers(rackNumbersData);

    //             const blockNumbersData = await apiRequest({ method: 'get', url: `block?status=1` });
    //             setBlockNumbers(blockNumbersData);

    //             const placesData = await apiRequest({ method: 'get', url: `place?status=1` });
    //             setPlaces(placesData);
    //         } catch (err) {
    //             showError('Failed to fetch dropdown data');
    //         }
    //     };

    //     if (visible) fetchData();
    // }, [visible]);

    const fetchData = async () => {
        try {
            const [unit, snsNom, sizeData, baseColordata, subColordata, ledgerData, ProductGradeData] = await Promise.all([
                apiRequest({ url: 'unit-types?status=1' }),
                apiRequest({ url: 'shade-numbers?status=1' }),
                apiRequest({ url: 'sizes?status=1' }),
                apiRequest({ url: 'base-colors?status=1' }),
                apiRequest({ url: 'sub-colors?status=1' }),
                apiRequest({ url: 'ledger-data?status=1' }),
                apiRequest({ url: 'product-grades?status=1' }),
            ]);

            setUnitTypes(unit || []);
            setSns(snsNom || []);
            setSizes(sizeData || []);
            setBcs(baseColordata || []);
            setScs(subColordata || []);
            setLedgers(ledgerData.ledgers || []);
            setProductGrades(ProductGradeData || []);

            // Sequential fetches

            const bookNumbersData = await apiRequest({ method: 'get', url: `book?status=1` });
            setBookNumbers(bookNumbersData);

            const cardNumbersData = await apiRequest({ method: 'get', url: `card?status=1` });
            setCardNumbers(cardNumbersData);

            const rackNumbersData = await apiRequest({ method: 'get', url: `rack?status=1` });
            setRackNumbers(rackNumbersData);

            const blockNumbersData = await apiRequest({ method: 'get', url: `block?status=1` });
            setBlockNumbers(blockNumbersData);

            const placesData = await apiRequest({ method: 'get', url: `place?status=1` });
            setPlaces(placesData);

            const sizesData = await apiRequest({ method: 'get', url: `sizes?status=1` });
            setSizes(sizesData);
            
            const ShadeNumberData = await apiRequest({ method: 'get', url: `shade-numbers?status=1` });
            setSns(ShadeNumberData);

            const BCData = await apiRequest({ method: 'get', url: `base-colors?status=1` });
            setBcs(BCData);

            const UtData = await apiRequest({ method: 'get', url: `unit-types?status=1` });
            setPus(UtData);

            const ScData = await apiRequest({ method: 'get', url: `sub-colors?status=1` });
            setScs(ScData);            
            
            const PgData = await apiRequest({ method: 'get', url: `product-grades?status=1` });
            setScs(PgData);

        } catch (err) {
            showError('Failed to fetch dropdown data');
        }
    };



    // useEffect(() => {
    //      if (visible) fetchData();
    //     if (visible && isEditMode && variantinitialValues) {
    //         form.setFieldsValue(variantinitialValues);
    //     } else if (visible && initialValues?.product_code) {
    //         form.resetFields();

    //         // Set default variant code
    //         if (productVariants && productVariants.length > 0) {
    //             const nextLetter = String.fromCharCode(65 + productVariants.length); // 65 = A
    //             const newCode = `${initialValues.product_code}-${nextLetter}`;
    //             form.setFieldsValue({ variant_code: newCode });
    //         } else {
    //             // First variant
    //             form.setFieldsValue({ variant_code: `${initialValues.product_code}-A` });
    //         }
    //     }
    // }, [visible, isEditMode, variantinitialValues, form, productVariants, initialValues]);

     // Book number
   
     useEffect(() => {
        if (visible) {
            fetchData();
        }

        if (visible && isEditMode && variantinitialValues) {
            form.setFieldsValue(variantinitialValues);
        } else if (visible && initialValues?.product_code && product_id) {
            form.resetFields();

            // Set default variant code
            if (productVariants && productVariants.length > 0) {
                const nextLetter = String.fromCharCode(65 + productVariants.length); // 65 = A
                const newCode = `${initialValues.product_code}-${nextLetter}`;
                form.setFieldsValue({ variant_code: newCode });
            } else {
                form.setFieldsValue({ variant_code: `${initialValues.product_code}-A` });
            }
        }
        console.log("initialValues.product_code",initialValues?.product_code)
    }, [visible, isEditMode, variantinitialValues, form, productVariants, initialValues, product_id]);

   
   
     const handleBookNumberCreated = (newBookNumber: BookNumbers) => {
        fetchData();
        setSelectedBooknumber(newBookNumber.book_id);
        setIsBooknumberModalVisible(false);
    };

    // Card number
    const handleCnCreated = (newCn: CardNumbers) => {
        fetchData();
        setSelectedCn(newCn.card_id);
        setIsCnModalVisible(false);
    };

    // Rack number
    const handleRnCreated = (newRn: RackNumbers) => {
        fetchData();
        setSelectedRn(newRn.rack_id);
        setIsRnModalVisible(false);
    };

    // Block number
    const handleBlocknumberCreated = (newBlocknumber: BlockNumbers) => {
        fetchData();
        setSelectedBlocknumber(newBlocknumber.block_id);
        setIsBlocknumberModalVisible(false);
    };

    // Place
    const handlePlaceCreated = (newPlace: Places) => {
        fetchData();
        setSelectedPlace(newPlace.place_id);
        setIsPlaceModalVisible(false);
    };

    // size
    const handleSizeCreated = (newSize: Size) => {
        fetchData();
        setSelectedSize(newSize.size_id);
        setIsSizeModalVisible(false);
    };

    // Shade
    const handleSnCreated = (newSn: Sn) => {
        fetchData();
        setSelectedSn(newSn.sn_id);
        setIsSnModalVisible(false);
    };

     // base color
    const handleBcCreated = (newBc: Bc) => {
        fetchData();
        setSelectedBcs(newBc.bc_id);
        setIsBcModalVisible(false);
    };

    // Unit type
    const handleUtCreated = (newUt: UnitType) => {
        fetchData();
        setSelectedUt(newUt.ut_id);
        setIsUtModalVisible(false);
    };

    // sub color
    const handleScCreated = (newSc: Sc) => {
        fetchData();
        setSelectedScs(newSc.sc_id);
        setIsScModalVisible(false);
    };


    // product grade
    const handlePgCreated = (newPg: ProductGrades) => {
        fetchData();
        setSelectedPg(newPg.pg_id);
        setIsPgModalVisible(false);
    };

    const handleSubmit = async (values: any) => {
        try {
            const selectedBookNumber = booknumbers.find((b) => b.book_id === values.variant_book_no);
            const selectedCardNumber = cardnumbers.find((c) => c.card_id === values.variant_card_no);
            const selectedRackNumber = RackNumbers.find((r) => r.rack_id === values.variant_rack_no);
            const selectedBlockNumber = blocknumbers.find((b) => b.block_id === values.variant_block_no);
            const selectedPlace = places.find((p) => p.place_id === values.variant_place_name);
            const selectedSize = sizes.find((s) => s.size_id === values.variant_size);
            const selectedShadeNumber = sns.find((sn) => sn.sn_id === values.variant_shade);
            const selectedBC = bcs.find((bc) => bc.bc_id === values.variant_base_color);
            const selectedUt = unitTypes.find((ut) => ut.ut_id === values.variant_unit);
            const selectedSc = scs.find((sc) => sc.sc_id === values.variant_sub_color);
            const selectedPg = productgrades.find((pg) => pg.pg_id === values.variant_product_grade);
            const payload = {
                ...values,
                variant_invoice_date: values.variant_invoice_date?.format('YYYY-MM-DD'),
                variant_id: variantinitialValues?.variant_id || null,
                variant_product_id:product_id,

                // Replace raw form values with matched IDs (if needed)
                variant_book_no: selectedBookNumber?.book_id || '',
                variant_card_no: selectedCardNumber?.card_id || '',
                variant_rack_no: selectedRackNumber?.rack_id || '',
                variant_block_no: selectedBlockNumber?.block_id || '',
                variant_place_name: selectedPlace?.place_id || '',
                variant_size: selectedSize?.size_id || '',
                variant_shade: selectedShadeNumber?.sn_id || '',
                variant_base_color: selectedBC?.bc_id || '',
                variant_unit: selectedUt?.ut_id || '',
                variant_sub_color: selectedSc?.sc_id || '',
                variant_product_grade: selectedPg?.pg_id || '',
            };

            const url = variantinitialValues?.variant_id ? 'edit-product-variant' : 'add-product-variant';
            const method = variantinitialValues?.variant_id ? 'put' : 'post';

            const response = await apiRequest({ url, method, data: payload });
            // Here is your generated ID
            console.log("New generated variant_id:", response.data.variant_id);

            // Save it to state if you need it right away
            setCurrentVariantId(response.data.variant_id);
            onCreate(response.data);
            showSuccess(variantinitialValues?.variant_id ? 'Variant updated' : 'Variant created');

            form.resetFields();
            if (isModalClose) onCancel();
        } catch (err) {
            showError('Error saving variant');
        }
    };

    const renderSelect = (name: string, label: string, options: any[], keyField: string, valueField: string) => (
        <Form.Item name={name} label={label} rules={[{ required: true, message: `Please select ${label}` }]}>
            <Select
                showSearch
                allowClear
                placeholder={`Select ${label}`}
                options={options?.map((item) => ({
                    label: item[valueField],
                    value: item[keyField],
                }))}
                filterOption={(input, option) =>
                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                }
            />
        </Form.Item>
    );

    const invoiceRate = Form.useWatch('variant_invoice_rate', form) ?? 0;
    const less = Form.useWatch('variant_less', form) ?? 0;
    const add = Form.useWatch('variant_add', form) ?? 0;
    const margin = Form.useWatch('variant_margin', form) ?? 0;

    // Update net cost and MRP dynamically
    React.useEffect(() => {
        let net = invoiceRate;
        net -= (net * less) / 100;
        net += (net * add) / 100;
        const mrp = net + (net * margin) / 100;

        form.setFieldsValue({
        variant_net_cost: parseFloat(net.toFixed(2)),
        variant_mrp: parseFloat(mrp.toFixed(2)),
        });
    }, [invoiceRate, less, add, margin]);

    const handleStatusToggle = async (BlockNumberId: number) => {
        setBlockNumbers((prev) =>
            prev.map((item) =>
                item.block_id === BlockNumberId
                    ? { ...item, block_status: item.block_status === 1 ? 0 : 1 }
                    : item
            )
        );

        try {
            await apiRequest({
                method: 'put',
                url: `/update-status-product-variant/${BlockNumberId}`,
            });
            showSuccess('block number status updated');
        } catch (error) {
            showError('Failed to update status');
            setBlockNumbers((prev) =>
                prev.map((item) =>
                    item.block_id === BlockNumberId
                        ? { ...item, block_status: item.block_status === 1 ? 0 : 1 }
                        : item
                )
            );
        }
    };

    return (
        <Modal
            title={isEditMode ? 'Edit Product Variant' : 'Add New Product Variant'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="95%"
            destroyOnClose
            centered
            maskClosable={false}
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>

                    {/* variant code */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_code" label="Variant Code"><Input /></Form.Item></Col>

                    {/* variant name */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_name" label="Variant Name"><Input /></Form.Item></Col>

                    
                    {/* shade number */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>Shade No</div>

                        <Form.Item name="variant_shade">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                showSearch
                                placeholder="Select Shade"
                                className="left-rounded"
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                    const selected = sns.find((shade) => shade.sn_id === value);
                                    if (selected) {
                                    form.setFieldsValue({ variant_shade: selected.sn_id });
                                    } else {
                                    form.setFieldsValue({ variant_shade: null });
                                    }
                                    setSelectedSn(value); // Optional state
                                }}
                                options={[
                                    { label: 'Select Shade', value: null },
                                    ...sns.map((shade) => ({
                                    label: shade.sn_number,
                                    value: shade.sn_id,
                                    })),
                                ]}
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                }
                                dropdownMatchSelectWidth={false}
                                value={form.getFieldValue('variant_shade')}
                                />
                            </div>

                            <Button
                                className="right-rounded"
                                style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsSnModalVisible(true)}
                            />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Shade Modal */}
                        <SnModal
                            visible={isSnModalVisible}
                            onCancel={() => setIsSnModalVisible(false)}
                            onCreate={handleSnCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Size */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Size
                        </div>

                        <Form.Item name="variant_size">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Size"
                                        className="left-rounded"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = sizes.find((s) => s.size_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ variant_size: selected.size_id });
                                            } else {
                                                form.setFieldsValue({ variant_size: null });
                                            }
                                            setSelectedSize(value);
                                        }}
                                        options={[
                                            { label: 'Select Size', value: null },
                                            ...sizes.map((size) => ({
                                                label: size.size_name,
                                                value: size.size_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('variant_size')}
                                    />
                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsSizeModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Size Modal */}
                        <SizeModel
                            visible={isSizeModalVisible}
                            onCancel={() => setIsSizeModalVisible(false)}
                            onCreate={handleSizeCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                     {/* base color */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>Base Color</div>

                        <Form.Item name="variant_base_color">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                showSearch
                                placeholder="Select Base Color"
                                className="left-rounded"
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                    const selected = bcs.find((baseColor) => baseColor.bc_id === value);
                                    if (selected) {
                                    form.setFieldsValue({ variant_base_color: selected.bc_id });
                                    } else {
                                    form.setFieldsValue({ variant_base_color: null });
                                    }
                                    setSelectedBcs(value); // Optional if you track selected state
                                }}
                                options={[
                                    ...bcs.map((bc) => ({
                                        label: (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <div
                                            style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: 4,
                                                backgroundColor: bc.bc_name || '#ccc',
                                                border: '1px solid #ddd',
                                                flexShrink: 0,
                                            }}
                                            />
                                            <span>{bc.bc_name}</span>
                                        </div>
                                        ),
                                        value: bc.bc_id,
                                    })),
                                ]}
                                allowClear
                                dropdownMatchSelectWidth={false}
                                value={form.getFieldValue('variant_base_color')}
                                />
                            </div>

                            <Button
                                className="right-rounded"
                                style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsBcModalVisible(true)}
                            />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Base Color Modal */}
                        <BcModal
                            visible={isBcModalVisible}
                            onCancel={() => setIsBcModalVisible(false)}
                            onCreate={handleBcCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                     {/* sub color */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>Sub Color</div>

                        <Form.Item name="variant_sub_color">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                showSearch
                                placeholder="Select Sub Color"
                                className="left-rounded"
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                    const selected = scs.find((subColor) => subColor.sc_id === value);
                                    if (selected) {
                                    form.setFieldsValue({ variant_sub_color: selected.sc_id });
                                    } else {
                                    form.setFieldsValue({ variant_sub_color: null });
                                    }
                                    setSelectedScs(value); // Optional if you track selected state
                                }}
                                options={[
                                    ...scs.map((sc) => ({
                                        label: (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <div
                                            style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: 4,
                                                backgroundColor: sc.sc_name || '#ccc',
                                                border: '1px solid #ddd',
                                                flexShrink: 0,
                                            }}
                                            />
                                            <span>{sc.sc_name}</span>
                                        </div>
                                        ),
                                        value: sc.sc_id,
                                    })),
                                ]}
                                allowClear
                                value={form.getFieldValue('variant_sub_color')}
                                />
                            </div>

                            <Button
                                className="right-rounded"
                                style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsScModalVisible(true)}
                            />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Sub Color Modal */}
                        <ScModal
                            visible={isScModalVisible}
                            onCancel={() => setIsScModalVisible(false)}
                            onCreate={handleScCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* product grade  */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>Product Grade</div>
                        <Form.Item name="variant_product_grade">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                showSearch
                                placeholder="Select Product Grade"
                                className="left-rounded"
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                    const selected = productgrades.find((pg) => pg.pg_id === value);
                                    if (selected) {
                                    form.setFieldsValue({ variant_product_grade: selected.pg_id });
                                    } else {
                                    form.setFieldsValue({ variant_product_grade: null });
                                    }
                                    setSelectedPg(value); // Optional state
                                }}
                                options={[
                                    { label: 'Select Product Grade', value: null },
                                    ...productgrades.map((pg) => ({
                                    label: pg.pg_name,
                                    value: pg.pg_id,
                                    })),
                                ]}
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                }
                                dropdownMatchSelectWidth={false}
                                value={form.getFieldValue('variant_product_grade')}
                                />
                            </div>

                            <Button
                                className="right-rounded"
                                style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsPgModalVisible(true)}
                            />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Product Grade Modal */}
                        <ProducrGradeModel
                            visible={isPgModalVisible}
                            onCancel={() => setIsPgModalVisible(false)}
                            onCreate={handlePgCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Qty (Mtr) */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_received_quantity_mtr" label="Qty (Mtr)"><Input type="number" /></Form.Item></Col>

                    
                    {/* Qty (Pcs) */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_received_quantity_pcs" label="Qty (Pcs)"><Input type="number" /></Form.Item></Col>


                    {/* umit */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>Unit</div>

                        <Form.Item name="variant_unit">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                showSearch
                                placeholder="Select Unit"
                                className="left-rounded"
                                style={{ width: '100%' }}
                                onChange={(value) => {
                                    const selected = unitTypes.find((unit) => unit.ut_id === value);
                                    if (selected) {
                                    form.setFieldsValue({ variant_unit: selected.ut_id });
                                    } else {
                                    form.setFieldsValue({ variant_unit: null });
                                    }
                                    setSelectedUt(value); // Optional state
                                }}
                                options={[
                                    { label: 'Select Unit', value: null },
                                    ...unitTypes.map((unit) => ({
                                    label: unit.ut_name,
                                    value: unit.ut_id,
                                    })),
                                ]}
                                allowClear
                                filterOption={(input, option) =>
                                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                }
                                dropdownMatchSelectWidth={false}
                                value={form.getFieldValue('variant_unit')}
                                />
                            </div>

                            <Button
                                className="right-rounded"
                                style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsUtModalVisible(true)}
                            />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Unit Modal */}
                        <UnitTypeModel
                            visible={isUtModalVisible}
                            onCancel={() => setIsUtModalVisible(false)}
                            onCreate={handleUtCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Stock Level */}
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item name="variant_stock_level" label="Stock Level">
                            <Input type="number" />
                        </Form.Item>
                    </Col>


                    <Divider/>

                    {/* Supplier Name */}
                    <Col xs={24} sm={12} md={8}>{renderSelect('variant_suppliar_ladger_id', 'Supplier Name', ledgers, 'ledger_id', 'ledger_first_name')}</Col>
                    
                    {/* invoice date */}
                    <Col md={8}><Form.Item name="variant_invoice_date" label="Invoice Date"><DatePicker style={{
                        width: '100%',
                        borderRadius: "20px",
                        height: "45px",
                    }} /></Form.Item></Col>


                    {/* invoice number */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_invoice_no" label="Invoice No"><Input /></Form.Item></Col>

                    
                    <Divider/>
                    
                    {/* invoice rate */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_invoice_rate" label="Invoice Rate"><Input type="number" /></Form.Item></Col>


                    {/* Less */}
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            name="variant_less"
                            label="Less (%)"
                            rules={[
                            { required: false },
                            {
                                type: 'number',
                                min: 0,
                                max: 100,
                                message: 'Value must be between 0 and 100',
                            },
                            ]}
                        >
                            <InputNumber min={0} max={100} style={{ width: '100%' }} />

                        </Form.Item>
                    </Col>


                   
                    {/* Add */}
                    <Col xs={24} sm={12} md={8}>
                            <Form.Item
                            name="variant_add"
                            label="Add (%)"
                            rules={[
                            { required: false },
                            {
                                type: 'number',
                                min: 0,
                                max: 100,
                                message: 'Value must be between 0 and 100',
                            },
                            ]}
                        >
                            <InputNumber min={0} max={100} style={{ width: '100%' }} />

                        </Form.Item>
                    </Col>
                   

                    {/* Net cost */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_net_cost" label="Net Cost"><Input disabled type="number" /></Form.Item></Col>


                    {/* Margin */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_margin" label="Margin (%)"><Input type="number" /></Form.Item></Col>


                    {/* MRP */}
                    <Col xs={24} sm={12} md={8}><Form.Item name="variant_mrp" label="MRP"><Input disabled type="number" /></Form.Item></Col>

                   
                    {/* Minimum Discount */}
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item name="variant_minimum_discount" label="Auto bill Discount (%)">
                            <Input type="number" />
                        </Form.Item>
                    </Col>

                    {/* <Col xs={24} sm={12} md={8}><Form.Item name="variant_margin_outside_stitching" label="Margin (Outside Stitching)"><Input type="number" /></Form.Item></Col> */}
                    


                    {/* <Col xs={24} sm={12} md={8}><Form.Item name="variant_outside_stitching" label="Outside Stitching"><Input type="number" /></Form.Item></Col> */}

                    
                    {/* <Col xs={24} sm={12} md={8}>
                        <Form.Item name="variant_margin_whole_sale" label="Margin (Wholesale)">
                            <Input type="number" />
                        </Form.Item>
                    </Col> */}
                    {/* <Col xs={24} sm={12} md={8}>
                        <Form.Item name="variant_whole_sale_rate" label="Wholesale Rate">
                            <Input type="number" />
                        </Form.Item>
                    </Col> */}

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item name="variant_maximum_discount" label="Maximum Discount (%)">
                            <Input type="number" />
                        </Form.Item>
                    </Col>

                     {/* Book Number */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Book No.
                        </div>

                        <Form.Item name="variant_book_no">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Book Number"
                                        className="left-rounded"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = booknumbers.find((book) => book.book_id === value);
                                            // form.setFieldsValue({
                                            //     variant_book_no: selected ? selected.book_id : null,
                                            // });
                                            if (selected) {
                                                form.setFieldsValue({ variant_book_no: selected.book_id });
                                            } else {
                                                form.setFieldsValue({ variant_book_no: null });
                                            }setSelectedBooknumber(value)
                                        }}
                                        options={[
                                            { label: 'Select Book Number', value: null },
                                            ...booknumbers.map((book) => ({
                                                label: book.book_number,
                                                value: book.book_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('variant_book_no')}
                                    />
                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsBooknumberModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Book Number Modal */}
                        <BookNumberModel
                            visible={isBooknumberModalVisible}
                            onCancel={() => setIsBooknumberModalVisible(false)}
                            onCreate={handleBookNumberCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Card Number */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Card No.
                        </div>

                        <Form.Item name="variant_card_no">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Card Number"
                                        className="left-rounded"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = cardnumbers.find((cn) => cn.card_id === value);
                                            // form.setFieldsValue({
                                            //     variant_card_no: selected ? selected.card_id : null,
                                            // });
                                            if (selected) {
                                                form.setFieldsValue({ variant_card_no: selected.card_id });
                                            } else {
                                                form.setFieldsValue({ variant_card_no: null });
                                            }setSelectedCn(value)
                                        }}
                                        options={[
                                            { label: 'Select Card Number', value: null },
                                            ...cardnumbers.map((cn) => ({
                                                label: cn.card_number,
                                                value: cn.card_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('variant_card_no')}
                                    />
                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsCnModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Card Number Modal */}
                        <CardNumberModel
                            visible={isCnModalVisible}
                            onCancel={() => setIsCnModalVisible(false)}
                            onCreate={handleCnCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>



                    {/* rack Number */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Rack No.
                        </div>

                        <Form.Item name="variant_rack_no">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Rack Number"
                                        className="left-rounded"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = RackNumbers.find((rn) => rn.rack_id === value);
                                            // form.setFieldsValue({
                                            //     variant_rack_no: selected ? selected.rack_id : null,
                                            // });
                                            if (selected) {
                                                form.setFieldsValue({ variant_rack_no: selected.rack_id });
                                            } else {
                                                form.setFieldsValue({ variant_rack_no: null });
                                            }setSelectedRn(value)
                                        }}
                                        options={[
                                            { label: 'Select Rack Number', value: null },
                                            ...RackNumbers.map((rn) => ({
                                                label: rn.rack_name,
                                                value: rn.rack_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('variant_rack_no')}
                                    />
                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsRnModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Rack Number Modal */}
                        <RackNumberModel
                            visible={isRnModalVisible}
                            onCancel={() => setIsRnModalVisible(false)}
                            onCreate={handleRnCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Block Number */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Block No.
                        </div>

                        <Form.Item name="variant_block_no">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Block Number"
                                        className="left-rounded"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = blocknumbers.find((block) => block.block_id === value);
                                            // form.setFieldsValue({
                                            //     variant_block_no: selected ? selected.block_id : null,
                                            // });
                                            if (selected) {
                                                form.setFieldsValue({ variant_block_no: selected.block_id });
                                            } else {
                                                form.setFieldsValue({ variant_block_no: null });
                                            }setSelectedBlocknumber(value)
                                        }}
                                        options={[
                                            { label: 'Select Block Number', value: null },
                                            ...blocknumbers.map((block) => ({
                                                label: block.block_number,
                                                value: block.block_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('variant_block_no')}
                                    />
                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsBlocknumberModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Block Number Modal */}
                        <BlockNumberModel
                            visible={isBlocknumberModalVisible}
                            onCancel={() => setIsBlocknumberModalVisible(false)}
                            onCreate={handleBlocknumberCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>



                    {/* Place */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Place Name
                        </div>

                        <Form.Item name="variant_place_name">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Place"
                                        className="left-rounded"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = places.find((place) => place.place_id === value);
                                            // form.setFieldsValue({
                                            //     variant_place_name: selected ? selected.place_id : null,
                                            // });
                                            if (selected) {
                                                form.setFieldsValue({ variant_place_name: selected.place_id });
                                            } else {
                                                form.setFieldsValue({ variant_place_name: null });
                                            }setSelectedPlace(value)
                                        }}
                                        options={[
                                            { label: 'Select Place', value: null },
                                            ...places.map((place) => ({
                                                label: place.place_name,
                                                value: place.place_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('variant_place_name')}
                                    />
                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsPlaceModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Place Modal */}
                        <PlaceModel
                            visible={isPlaceModalVisible}
                            onCancel={() => setIsPlaceModalVisible(false)}
                            onCreate={handlePlaceCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                </Row>

                <Form.Item style={{ textAlign: 'right' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && (
                            <Button
                                type="primary"
                                htmlType="submit"
                                onClick={() => setIsModalClose(false)}
                            >
                                Submit & Create Another
                            </Button>
                        )}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                        >
                            Save
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default VariantsModel;
